export class CurlValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'CurlValidationError';
  }
}
